<template>
    <div class="profile">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/personal/lesson' }">我的主页</el-breadcrumb-item>
                <el-breadcrumb-item>修改资料</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row class="profile-body">
                <el-col :span="3">
                    <el-menu
                        class="profile-menu"
                        :default-active="activeComponent"
                        @select="handleSelect"
                    >
                        <el-menu-item v-for="menu in menus" :key="menu.id" :index="menu.component">
                            <i :class="menu.icon" />
                            <span slot="title" v-text="menu.name" />
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="21">
                    <el-card class="profile-card" shadow="never">
                        <keep-alive>
                            <component :is="activeComponent" />
                        </keep-alive>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import basicInformation from "./components/basic-information";
import socialMedia from "./components/profile-social-media";
import inviteInfo from "./components/profile-invite-info";
import scialAccount from "./components/profile-social-account";
import modifyEmail from "./components/modify-email";
import activeEmail from "./components/active-email";

export default {
    data() {
        return {
            activeComponent: ""
        };
    },
    components: {
        basicInformation,
        socialMedia,
        inviteInfo,
        modifyEmail,
        activeEmail,
        scialAccount
    },
    computed: {
        ...mapGetters(["userInfo", "isTeacher"]),
        menus() {
            let list = [
                { id: 1, name: '基本信息', icon: 'el-icon-notebook-1', component: 'basicInformation' },
                { id: 2, name: '账号信息', icon: 'el-icon-s-help', component: 'socialMedia' },
                { id: 4, name: '社交账号', icon: 'el-icon-s-comment', component: 'scialAccount' },
            ]

            if(this.isTeacher) {
                list.push({ id: 3, name: '开课信息', icon: 'el-icon-thumb', component: 'inviteInfo' })
            }

            return list
        }
        // menus() {
        //     if (this.userInfo.emailActivation == 1) {
        //         menus.push({
        //             id: 2,
        //             name: "修改邮箱",
        //             icon: "el-icon-message",
        //             component: "modifyEmail"
        //         });
        //     }else if(this.userInfo.emailActivation == 0){
        //        menus.push({
        //             id: 4,
        //             name: "激活邮箱",
        //             icon: "el-icon-connection",
        //             component: "activeEmail"
        //         });
        //     }
        //     menus.sort(this.compare("id"))
        //     return menus;
        // }
    },
    watch: {
        '$route'(val) {
            const { type } = val.query
            if(this.menus.some(item => item.component === type)) {
                this.activeComponent = type;
            } else {
                this.activeComponent = this.menus[0].component
            }
        }
    },
    methods: {
        handleSelect(type) {
            this.activeComponent = type;
            this.$router.push({
                path: "/users/profile",
                query: {
                    type
                }
            });
        },
        compare(property) {
            return function(a, b) {
                const value1 = a[property];
                const value2 = b[property];
                return value1 - value2;
            };
        }
    },
    created() {
        let name = this.menus[0].component;
        if (this.$route.query.type) {
            name = this.$route.query.type;
        }
        this.handleSelect(name);
    }
};
</script>

<style lang="scss" scoped>
.profile {
    margin-top: -6px;
    padding-top: 12px;
    padding-bottom: 40px;
    .el-breadcrumb {
        line-height: 2em;
        margin-bottom: 12px;
    }
    .profile-body {
        min-height: 700px;
        > .el-col {
            &:not(:first-child) {
                padding-left: 6px;
            }
            &:not(:last-child) {
                padding-right: 6px;
            }
        }
        .profile-menu,
        .profile-card {
            min-height: 570px;
        }
        .profile-menu {
            padding-top: 24px;
            .el-menu-item {
                height: auto;
                line-height: 4em;
            }
        }
    }
}
</style>
